import { blue, ColorScale, gray, green, red, yellow } from 'bold-ui/lib/styles/colors'
import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { Color } from 'csstype'

export enum TipoSolicitacaoRegulacaoEnum {
  EXAME = 'EXAME',
  LABORATORIO = 'LABORATORIO',
  CONSULTA = 'CONSULTA',
}

export enum ClassificacaoRiscoVulnerabilidadeEnum {
  MUITO_ALTO = 'MUITO_ALTO',
  ALTO = 'ALTO',
  MODERADO = 'MODERADO',
  BAIXO = 'BAIXO',
  NAO_CLASSIFICADO = 'NAO_CLASSIFICADO',
}

export const classificacaoRiscoVulnerabilidadeRecord: Record<
  ClassificacaoRiscoVulnerabilidadeEnum,
  { label: string; mainColor: Color; colorScale: ColorScale }
> = {
  [ClassificacaoRiscoVulnerabilidadeEnum.MUITO_ALTO]: { label: '0 - Muito alto', mainColor: red.c40, colorScale: red },
  [ClassificacaoRiscoVulnerabilidadeEnum.ALTO]: { label: '1 - Alto', mainColor: yellow.c60, colorScale: yellow },
  [ClassificacaoRiscoVulnerabilidadeEnum.MODERADO]: { label: '2 - Moderado', mainColor: green.c40, colorScale: green },
  [ClassificacaoRiscoVulnerabilidadeEnum.BAIXO]: { label: '3 - Baixo', mainColor: blue.c40, colorScale: blue },
  [ClassificacaoRiscoVulnerabilidadeEnum.NAO_CLASSIFICADO]: {
    label: 'Não Classificado',
    mainColor: gray.c40,
    colorScale: gray,
  },
}

export const headerContentTab: Record<TipoSolicitacaoRegulacaoEnum, { title: string; description: string }> = {
  [TipoSolicitacaoRegulacaoEnum.EXAME]: {
    title: 'Solicitar exame e outros',
    description:
      'Os procedimentos disponíveis para solicitação são definidos a partir do e-SUS Regulação, incluindo exames, grupos de exames e OCIs.',
  },
  [TipoSolicitacaoRegulacaoEnum.LABORATORIO]: {
    title: 'Solicitar laboratório',
    description: 'Os procedimentos laboratoriais disponíveis são definidos a partir do e-SUS Regulação.',
  },
  [TipoSolicitacaoRegulacaoEnum.CONSULTA]: {
    title: 'Solicitar consulta',
    description: 'As consultas disponíveis são definidas a partir do e-SUS Regulação.',
  },
}

export const tabLabelByTipo: Partial<Record<TipoSolicitacaoRegulacaoEnum, string>> = {
  [TipoSolicitacaoRegulacaoEnum.EXAME]: 'Exame',
  [TipoSolicitacaoRegulacaoEnum.LABORATORIO]: 'Laboratório',
}

export const SOLICITAR_ENCAMINHAMENTO_URL = '/solicitar-encaminhamento-regulacao'
export const SOLICITAR_REGULACAO_URL = '/solicitar-regulacao'

export interface ProcedimentoRegulacaoSelectModel {
  id: ID
  nome: string
  codigo?: string
}

export interface CentralExecutanteSelectModel {
  id: ID
  nome: string
}

export interface SolicitacaoRegulacaoModel {
  tipo: TipoSolicitacaoRegulacaoEnum
  procedimento?: ProcedimentoRegulacaoSelectModel
  possuiConsultaRetorno?: boolean
  centralExecutante?: CentralExecutanteSelectModel
  cid10?: CidSelectFieldModel
  possuiAlergia?: boolean
  descricaoAlergia?: string
  possuiDeficiencia?: boolean
  descricaoDeficiencia?: string
  classificacaoRisco?: ClassificacaoRiscoVulnerabilidadeEnum
  justificativa?: string
  solicitacaoJudicializada?: boolean
  descricaoSolicitacaoJudicializada?: string
}
